import * as React from 'react';
import { createElement } from 'react';
import './style.less';
import iconDown from './imgs/icon_down.svg';
import iconUp from './imgs/icon_up.svg';
TextCard.defaultProps = {
    icon: '',
    showIcon: true,
};
function TextCard(props) {
    const { text, children, style, icon, showIcon, onIconClick } = props;
    const [up, setUp] = React.useState(true);
    let iconSource = '';
    if (icon) {
        iconSource = icon;
    }
    else if (up) {
        iconSource = iconUp;
    }
    else {
        iconSource = iconDown;
    }
    let innerStyle = {};
    if (!up && !onIconClick) {
        innerStyle = {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        };
    }
    return (createElement("div", { className: `text-card-wrapper${showIcon ? '' : ' hide-icon'}`, style: { ...innerStyle, ...style } },
        children || text,
        showIcon && (createElement("div", { className: "text-card-icon", onClick: () => {
                if (onIconClick) {
                    onIconClick();
                }
                else {
                    setUp(!up);
                }
            } },
            createElement("img", { src: iconSource, alt: "icon" })))));
}
export default TextCard;
export { TextCardProps } from './PropsType';
